module.exports = __webpack_public_path__ + "img/landing1.b566e219.jpg";